import { ThemeType, CssType } from '../../../theming/jssTypes';

export const styles = (theme: ThemeType): CssType => ({
  drawer: {
    '& .ant-drawer-content-wrapper': {
      width: '480px !important',
    },
    '& .ant-drawer-header': {
      borderBottom: `1px solid ${theme.colors.borderColor}`,
      padding: '12px 16px',
      backgroundColor: theme.colors.surfaceBg,
    },
    '& .ant-drawer-title': {
      fontSize: theme.sizes.subHeading,
      fontWeight: 600,
      color: theme.colors.globalHeader,
      width: '100%',
    },
    '& .ant-drawer-body': {
      padding: '0',
      display: 'flex',
      flexDirection: 'column',
      height: 'calc(100vh - 72px)',
    },
    '& .ant-drawer-header-title': {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      justifyContent: 'start',
    },
  },
  chatContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflow: 'hidden',
  },
  chatHeader: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: '0',
    gap: '8px',
  },
  chatHeaderTop: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  chatHeaderLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    flex: 1,
  },
  chatBrand: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  chatLogo: {
    width: '32px',
    height: '32px',
    background: theme.colors.primaryColor,
    borderRadius: '6px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.colors.textOnDarkBg,
    '& svg': {
      color: theme.colors.textOnDarkBg,
    },
  },
  chatTitle: {
    fontSize: theme.sizes.subHeading,
    fontWeight: 600,
    color: theme.colors.globalHeader,
    margin: 0,
  },
  newChatBtn: {
    background: theme.colors.tableHeader,
    border: `1px solid ${theme.colors.borderColor}`,
    borderRadius: '6px',
    width: '24px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    color: theme.colors.tertiaryText,
    transition: 'all 0.2s ease',
    fontSize: '14px',
    fontWeight: 500,
    marginLeft: '4px',
    '&:hover': {
      background: theme.colors.HoverOnWhiteBg,
      color: theme.colors.secondaryText,
      borderColor: theme.colors.tertiaryText,
    },
  },
  personaSelector: {
    display: 'flex',
    gap: '2px',
    borderRadius: '6px',
    padding: '1px',
  },
  personaBtn: {
    border: 'none',
    borderRadius: '4px',
    fontSize: '11px',
    background: theme.colors.secondaryDisabledFill,
    fontWeight: 500,
    color: theme.colors.tertiaryText,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    transition: 'all 0.2s ease',
    '&:hover': {
      background: theme.colors.HoverOnWhiteBg,
      color: theme.colors.secondaryText,
    },
    '&.active': {
      background: theme.colors.primaryColor,
      color: theme.colors.textOnDarkBg,
      '& svg': {
        color: theme.colors.textOnDarkBg,
      },
    },
    '& svg': {
      color: theme.colors.tertiaryText,
    },
  },
  agentContext: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    fontSize: theme.sizes.caption,
    color: theme.colors.tertiaryText,
  },
  contextIcon: {
    width: '16px',
    height: '16px',
    borderRadius: '4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&.bi': {
      background: theme.colors.filterSelectionColor,
      color: theme.colors.primaryColor,
    },
    '&.support': {
      background: theme.colors.selectionOnWhiteBg,
      color: theme.colors.secondaryColor,
    },
  },
  themeToggle: {
    background: theme.colors.tableHeader,
    border: `1px solid ${theme.colors.borderColor}`,
    borderRadius: '6px',
    width: '32px',
    height: '32px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    color: theme.colors.tertiaryText,
    transition: 'all 0.2s ease',
    margin: '0 24px',
    '&:hover': {
      background: theme.colors.HoverOnWhiteBg,
      color: theme.colors.secondaryText,
      borderColor: theme.colors.tertiaryText,
    },
  },
  statusIndicator: {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    background: theme.colors.success,
    border: `2px solid ${theme.colors.surfaceBg}`,
    boxShadow: `0 0 0 1px ${theme.colors.borderColor}`,
  },
  headerStatus: {
    color: theme.colors.tertiaryText,
    fontSize: theme.sizes.caption,
    marginTop: '2px',
    display: 'flex',
    alignItems: 'center',
  },
  agentSelector: {
    display: 'none',
  },
  aiPanelTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    padding: '0',
    gap: '16px',
  },
  aiPanelLeft: {
    display: 'none',
  },
  aiPanelCenter: {
    display: 'none',
  },
  aiPanelRight: {
    display: 'none',
  },
  aiAvatar: {
    width: '32px',
    height: '32px',
    background: theme.colors.primaryColor,
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.colors.textOnDarkBg,
    fontWeight: 600,
    fontSize: '14px',
  },
  aiPanelInfo: {
    display: 'flex',
    flexDirection: 'column',
    '& h3': {
      fontSize: '15px',
      fontWeight: 600,
      color: theme.colors.globalHeader,
      margin: 0,
      lineHeight: 1.2,
    },
    '& p': {
      fontSize: '11px',
      color: theme.colors.tertiaryText,
      margin: 0,
    },
  },
  messageList: {
    flex: 1,
    overflowY: 'auto',
    padding: '16px',
    backgroundColor: theme.colors.pageBg,
    '&::-webkit-scrollbar': {
      width: '6px',
    },
    '&::-webkit-scrollbar-track': {
      background: theme.colors.secondaryDisabledFill,
    },
    '&::-webkit-scrollbar-thumb': {
      background: theme.colors.primaryDisabledFill,
      borderRadius: '3px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: theme.colors.tertiaryText,
    },
  },
  messageItem: {
    marginBottom: '8px',
    display: 'flex',
    alignItems: 'flex-start',
    gap: '10px',
    padding: 0,
    border: 'none',
    '&:last-child': {
      marginBottom: '0',
    },
  },
  userMessageItem: {
    flexDirection: 'row-reverse',
  },
  messageAvatar: {
    width: '32px',
    height: '32px',
    borderRadius: '50%',
    background: theme.colors.primaryColor,
    color: theme.colors.textOnDarkBg,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: theme.sizes.bodyText,
    fontWeight: 600,
    flexShrink: 0,
  },
  userMessageAvatar: {
    background: theme.colors.globalHeader,
  },
  messageContent: {
    flex: 1,
    maxWidth: 'calc(100% - 60px)',
  },
  userMessage: {
    background: theme.colors.primaryColor,
    color: theme.colors.textOnDarkBg,
    border: `1px solid ${theme.colors.primaryColor}`,
    borderRadius: '12px',
    padding: '16px',
    fontSize: theme.sizes.bodyText,
    lineHeight: '1.5',
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
    wordWrap: 'break-word',
    textAlign: 'left',
  },
  aiMessage: {
    background: theme.colors.surfaceBg,
    border: `1px solid ${theme.colors.borderColor}`,
    borderRadius: '12px',
    padding: '16px',
    fontSize: theme.sizes.bodyText,
    lineHeight: '1.5',
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
    wordWrap: 'break-word',
    textAlign: 'left',
  },
  messageTime: {
    fontSize: '11px',
    color: theme.colors.disabledText,
    marginTop: '8px',
    padding: '0 4px',
  },
  inputContainer: {
    borderTop: `1px solid ${theme.colors.borderColor}`,
    padding: '16px 20px',
    backgroundColor: theme.colors.surfaceBg,
    flexShrink: 0,
  },
  inputWrapper: {
    position: 'relative',
    display: 'flex',
    alignItems: 'flex-end',
    gap: '12px',
  },
  input: {
    flex: 1,
    border: `1px solid ${theme.colors.borderColor}`,
    borderRadius: '20px',
    padding: '12px 50px 12px 16px',
    fontSize: theme.sizes.bodyText,
    resize: 'none',
    minHeight: '44px',
    maxHeight: '120px',
    outline: 'none',
    transition: 'border-color 0.2s',
    fontFamily: 'inherit',
    '&:focus': {
      borderColor: theme.colors.primaryColor,
    },
    '& .ant-input': {
      border: 'none',
      boxShadow: 'none',
      padding: 0,
      backgroundColor: 'transparent',
    },
  },
  sendButton: {
    position: 'absolute',
    right: '8px',
    bottom: '8px',
    background: theme.colors.primaryColor,
    color: theme.colors.textOnDarkBg,
    border: 'none',
    width: '32px',
    height: '32px',
    borderRadius: '50%',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'background-color 0.2s',
    '&:hover': {
      background: theme.colors.secondaryColor,
    },
    '&:disabled': {
      opacity: 0.5,
      cursor: 'not-allowed',
    },
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    padding: '10px 0',
    alignItems: 'center',
  },
  loadingAnimation: {
    width: '32px',
    height: '32px',
    marginRight: '12px',
    '& svg': {
      width: '100%',
      height: '100%',
      fill: theme.colors.primaryColor,
      filter: `drop-shadow(0 0 12px ${theme.colors.primaryColor}40)`,
    },
  },
  compactLoadingAnimation: {
    width: '18px',
    height: '18px',
    flexShrink: 0,
    '& svg': {
      width: '100%',
      height: '100%',
    },
  },
  loadingText: {
    color: theme.colors.tertiaryText,
    fontSize: theme.sizes.bodyText,
    fontStyle: 'italic',
  },
  compactLoadingText: {
    color: theme.colors.disabledText,
    fontSize: '11px',
    fontWeight: 400,
    opacity: 0.8,
  },
  welcomeContainer: {
    textAlign: 'center',
    backgroundColor: theme.colors.pageBg,
  },
  welcomeTitle: {
    fontSize: theme.sizes.bodyText,
    fontWeight: 600,
    margin: '16px 0 8px 0',
    color: theme.colors.globalHeader,
  },
  welcomeDescription: {
    color: theme.colors.tertiaryText,
    fontSize: theme.sizes.bodyText,
    marginBottom: '12px',
    lineHeight: '1.5',
  },
  suggestions: {
    padding: '0 16px 12px',
    backgroundColor: theme.colors.pageBg,
    width: '100%',
  },
  suggestionsTitle: {
    fontSize: theme.sizes.caption,
    color: theme.colors.tertiaryText,
    marginBottom: '12px',
    fontWeight: 500,
  },
  suggestionsGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '8px',
  },
  suggestionCard: {
    background: theme.colors.surfaceBg,
    border: `1px solid ${theme.colors.borderColor}`,
    borderRadius: '8px',
    padding: '12px',
    cursor: 'pointer',
    transition: 'all 0.2s',
    fontSize: '13px',
    color: theme.colors.globalHeader,
    textAlign: 'center',
    '&:hover': {
      borderColor: theme.colors.primaryColor,
      background: theme.colors.tableHeader,
    },
    '& .ant-card-body': {
      padding: 0,
    },
  },
  suggestionIcon: {
    fontSize: '16px',
    marginBottom: '4px',
    display: 'block',
  },
  suggestionTitle: {
    fontWeight: 500,
    marginBottom: '2px',
    fontSize: '13px',
  },
  suggestionSubtitle: {
    fontSize: '11px',
    color: theme.colors.tertiaryText,
  },
  toolCallContainer: {
    marginTop: '6px',
    marginBottom: '4px',
    border: `1px solid ${theme.colors.borderColor}`,
    borderRadius: '6px',
    overflow: 'hidden',
    background: theme.colors.tableHeader,
    fontSize: theme.sizes.caption,
  },
  toolCallHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '8px 12px',
    backgroundColor: theme.colors.HoverOnWhiteBg,
    borderBottom: `1px solid ${theme.colors.borderColor}`,
    cursor: 'pointer',
    fontSize: theme.sizes.caption,
    fontWeight: 500,
    color: theme.colors.secondaryText,
    minHeight: 'auto',
    '&:hover': {
      backgroundColor: theme.colors.borderColor,
    },
  },
  toolCallName: {
    fontWeight: 500,
    fontSize: theme.sizes.caption,
    color: theme.colors.secondaryText,
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
  },
  toolCallTime: {
    fontSize: '11px',
    color: theme.colors.tertiaryText,
  },
  toolCallResponse: {
    padding: '12px',
    backgroundColor: theme.colors.surfaceBg,
    border: 'none',
    maxHeight: '250px',
    overflow: 'auto',
    fontFamily: "'Courier New', monospace",
    fontSize: '11px',
    color: theme.colors.secondaryText,
    lineHeight: '1.4',
    '&::-webkit-scrollbar': {
      width: '4px',
    },
    '&::-webkit-scrollbar-track': {
      background: theme.colors.secondaryDisabledFill,
    },
    '&::-webkit-scrollbar-thumb': {
      background: theme.colors.primaryDisabledFill,
      borderRadius: '2px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: theme.colors.tertiaryText,
    },
  },
  toolCallIcon: {
    color: theme.colors.primaryColor,
  },
  toolCallStatusIcon: {
    fontSize: '14px',
    marginRight: '4px',
  },
  toolCallStatus: {
    fontSize: '11px',
    fontWeight: 500,
    marginRight: '8px',
  },
  toolCallStatusPending: {
    color: theme.colors.warning,
  },
  toolCallStatusRunning: {
    color: theme.colors.primaryColor,
  },
  toolCallStatusCompleted: {
    color: theme.colors.success,
  },
  toolCallStatusFailed: {
    color: theme.colors.error,
  },
  toolCallStatusIconPending: {
    color: theme.colors.warning,
  },
  toolCallStatusIconRunning: {
    color: theme.colors.primaryColor,
  },
  toolCallStatusIconCompleted: {
    color: theme.colors.success,
  },
  toolCallStatusIconFailed: {
    color: theme.colors.error,
  },
  toolCallErrorText: {
    color: theme.colors.error,
  },
  toolCallProcessingText: {
    color: theme.colors.primaryColor,
    fontStyle: 'italic',
  },
  toolCallPendingText: {
    color: theme.colors.warning,
    fontStyle: 'italic',
  },
  toolCallResponseLabel: {
    marginBottom: '8px',
    fontWeight: 500,
    color: theme.colors.secondaryText,
  },
  toolCallResponseContent: {
    margin: 0,
    whiteSpace: 'pre-wrap',
    fontSize: '11px',
    lineHeight: '1.4',
    color: theme.colors.secondaryText,
    backgroundColor: theme.colors.pageBg,
    padding: '8px',
    borderRadius: '4px',
    border: `1px solid ${theme.colors.borderColor}`,
  },
  apiEndpoint: {
    background: theme.colors.success,
    color: theme.colors.textOnDarkBg,
    padding: '2px 6px',
    borderRadius: '3px',
    fontSize: theme.sizes.caption,
    fontWeight: 500,
    marginRight: '8px',
  },
  statusBadge: {
    background: theme.colors.success,
    color: theme.colors.textOnDarkBg,
    padding: '2px 6px',
    borderRadius: '3px',
    fontSize: theme.sizes.caption,
    fontWeight: 500,
  },
  chatHeaderContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
  },
  welcomeWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '100%',
    width: '100%',
    backgroundColor: theme.colors.pageBg,
  }
}); 